import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useRealmApp } from '../RealmApp';

const useStores = () => {
  const app = useRealmApp();
  const { stores, loading } = useAllStores(app.currentUser.id);
  return {
    loading,
    stores,
  };
};

export default useStores;

function useAllStores(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getStores($ownerId: String!) {
        stores(query: { owner_id: $ownerId }) {
          _id
          address1
          address2
          city
          country
          email
          coordinates
          image
          color
          language
          name
          phone
          phone2
          terminals
          webPage
          zip
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const stores = data?.stores ?? [];
  return { stores, loading };
}
